/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tier } from './Tier';
import {
    TierFromJSON,
    TierFromJSONTyped,
    TierToJSON,
    TierToJSONTyped,
} from './Tier';

/**
 * Detailed subscription with related tier and company info
 * @export
 * @interface SubscriptionDetailed
 */
export interface SubscriptionDetailed {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailed
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetailed
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    tierCode: SubscriptionDetailedTierCodeEnum;
    /**
     * Billing period for the subscription
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    billingPeriod: SubscriptionDetailedBillingPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    status: SubscriptionDetailedStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    stripeCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    stripeSubscriptionId?: string | null;
    /**
     * Tier code that will be applied at renewsAt (period end)
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    scheduledTierCode?: SubscriptionDetailedScheduledTierCodeEnum | null;
    /**
     * Start of current billing period from Stripe
     * @type {Date}
     * @memberof SubscriptionDetailed
     */
    currentPeriodStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionDetailed
     */
    renewsAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionDetailed
     */
    canceledAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionDetailed
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionDetailed
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Tier}
     * @memberof SubscriptionDetailed
     */
    tier?: Tier;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetailed
     */
    companyName?: string | null;
}


/**
 * @export
 */
export const SubscriptionDetailedTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type SubscriptionDetailedTierCodeEnum = typeof SubscriptionDetailedTierCodeEnum[keyof typeof SubscriptionDetailedTierCodeEnum];

/**
 * @export
 */
export const SubscriptionDetailedBillingPeriodEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type SubscriptionDetailedBillingPeriodEnum = typeof SubscriptionDetailedBillingPeriodEnum[keyof typeof SubscriptionDetailedBillingPeriodEnum];

/**
 * @export
 */
export const SubscriptionDetailedStatusEnum = {
    Active: 'active',
    PastDue: 'past_due',
    Canceled: 'canceled'
} as const;
export type SubscriptionDetailedStatusEnum = typeof SubscriptionDetailedStatusEnum[keyof typeof SubscriptionDetailedStatusEnum];

/**
 * @export
 */
export const SubscriptionDetailedScheduledTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type SubscriptionDetailedScheduledTierCodeEnum = typeof SubscriptionDetailedScheduledTierCodeEnum[keyof typeof SubscriptionDetailedScheduledTierCodeEnum];


/**
 * Check if a given object implements the SubscriptionDetailed interface.
 */
export function instanceOfSubscriptionDetailed(value: object): value is SubscriptionDetailed {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('billingPeriod' in value) || value['billingPeriod'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('renewsAt' in value) || value['renewsAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SubscriptionDetailedFromJSON(json: any): SubscriptionDetailed {
    return SubscriptionDetailedFromJSONTyped(json, false);
}

export function SubscriptionDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'tierCode': json['tierCode'],
        'billingPeriod': json['billingPeriod'],
        'status': json['status'],
        'stripeCustomerId': json['stripeCustomerId'] == null ? undefined : json['stripeCustomerId'],
        'stripeSubscriptionId': json['stripeSubscriptionId'] == null ? undefined : json['stripeSubscriptionId'],
        'scheduledTierCode': json['scheduledTierCode'] == null ? undefined : json['scheduledTierCode'],
        'currentPeriodStart': json['currentPeriodStart'] == null ? undefined : (new Date(json['currentPeriodStart'])),
        'renewsAt': (new Date(json['renewsAt'])),
        'canceledAt': json['canceledAt'] == null ? undefined : (new Date(json['canceledAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'tier': json['tier'] == null ? undefined : TierFromJSON(json['tier']),
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

export function SubscriptionDetailedToJSON(json: any): SubscriptionDetailed {
    return SubscriptionDetailedToJSONTyped(json, false);
}

export function SubscriptionDetailedToJSONTyped(value?: Omit<SubscriptionDetailed, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'tierCode': value['tierCode'],
        'billingPeriod': value['billingPeriod'],
        'status': value['status'],
        'stripeCustomerId': value['stripeCustomerId'],
        'stripeSubscriptionId': value['stripeSubscriptionId'],
        'scheduledTierCode': value['scheduledTierCode'],
        'currentPeriodStart': value['currentPeriodStart'] == null ? undefined : ((value['currentPeriodStart'] as any).toISOString()),
        'renewsAt': ((value['renewsAt']).toISOString()),
        'canceledAt': value['canceledAt'] == null ? undefined : ((value['canceledAt'] as any).toISOString()),
        'tier': TierToJSON(value['tier']),
        'companyName': value['companyName'],
    };
}

